module.exports = __webpack_public_path__ + "static/media/papelarlasPokSi.96061e2c.png";